import React, { useCallback, useEffect, useState } from "react";
import { message } from "antd";

import { remove, select as selectRequiriment } from "../actions/dimensionsAndType";
import { WrappedFormRequirement } from "./formRequirement";
import { downloadFile } from "../../../components/util";
import { ColumnProps, PaginationConfig, SorterResult } from "antd/lib/table";
import { IRequirement, IRequirementListResponse } from "./types";
import { Utilitaries } from "../../../business";
import { ITableFilter, ITableSort, QmKeyObject } from "../components/types";
import { QmDimensionTable } from "../components/qmTable";

const listName = "requisitos";
const REPORT_PARAMS = {
    accao: "lista",
    lista: listName,
    campos: "tipo_requisito:400:Tipo de requisito;designacao:400:Requisito;",
    titulo: "Requisitos",
};

export function Requirement() {
    const [dataSource, setDataSource] = useState<IRequirement[]>([]);
    const [loadingData, setLoadingData] = useState(true);

    const [showDeleteRecords, setShowDeleteRecords] = useState(false);
    const [filter, setFilter] = useState<ITableFilter>({
        pagination: {
            page: 1,
            perPage: 0,
        },
        filter: {},
    });

    const [editRow, setEditRow] = useState<IRequirement | null>(null);
    const [showModalNew, setShowModalNew] = useState(false);

    const getRequirement = useCallback(() => {
        setLoadingData(true);
        selectRequiriment({
            accao: "lista",
            lista: listName,
            pagina: 1,
            resultados_pagina: 0,
            mostra_lista_eliminados: showDeleteRecords,
        })
            .then((responses: IRequirementListResponse) => {
                const list: IRequirement[] = Utilitaries.toArray(responses.linha);
                const data = list.map((item) => {
                    return {
                        ...item,
                        designacao: typeof item.designacao === "object" ? "" : item.designacao,
                    };
                });

                setDataSource(data);
                setLoadingData(false);
            })
            .catch(() => {
                message.error("Ocorreu um erro ao carregar os tipos de requisitos.");
            });
    }, [showDeleteRecords]);

    useEffect(() => {
        getRequirement();
    }, [getRequirement]);

    async function onExportList(type: "pdf" | "xls") {
        const params = {
            ...REPORT_PARAMS,
            filter,
            saida: type,
            downloadInBrowser: true,
        };
        await downloadFile("gerelistas.php", params);
    }

    function toggleShowDelete(value: boolean) {
        setShowDeleteRecords(value);
    }

    function handleNew() {
        setShowModalNew(true);
    }

    function handleCloseNew(reload?: boolean) {
        if (reload) {
            getRequirement();
        }
        setShowModalNew(false);
    }

    function handleEdit(row: IRequirement) {
        setEditRow(row);
    }

    function handleCloseEdit(reload?: boolean) {
        if (reload) {
            getRequirement();
        }
        setEditRow(null);
    }

    function deleteRow(id: string) {
        remove({
            accao: "eliminar",
            lista: listName,
            chave1: id,
        }).then((sucess) => {
            if (sucess) {
                message.success("Linha eliminada com sucesso");
                getRequirement();
            } else {
                message.error("Ocorreu um erro");
            }
        });
    }

    function handleTableChange(
        _: PaginationConfig,
        filters: Partial<Record<keyof IRequirement, string[]>>,
        sorter: SorterResult<IRequirement>
    ) {
        const objFilter: QmKeyObject = {};

        if (filters) {
            Object.entries(filters).forEach(([key, val]) => {
                if (val && val[0]) objFilter[key] = val[0];
            });
        }

        let sortObj: ITableSort | null = null;
        if (sorter.columnKey && sorter.order) {
            sortObj = {
                sorterBy: sorter.columnKey,
                sorterOrder: sorter.order,
            };
        }

        setFilter((state) => ({
            ...state,
            pagination: {
                ...state.pagination,
                page: 1,
            },
            filter: objFilter,
            sorter: sortObj ?? undefined,
        }));
    }

    const columns: ColumnProps<IRequirement>[] = [
        {
            title: "Tipo de requisito",
            dataIndex: "tipo_requisito",
            width: "30%",
            ...QmDimensionTable.columnsSearch("tipo_requisito"),
        },
        {
            title: "Requisito",
            dataIndex: "designacao",
            width: "50%",
            ...QmDimensionTable.columnsSearch("designacao"),
        },
        {
            title: "Ações",
            dataIndex: "actions",
            width: "20%",
            render: (_, record) =>
                record._eliminado_ === "t" ? (
                    <QmDimensionTable.actions
                        deleteRow={() => deleteRow(record.id_requisito)}
                        handleEdit={() => handleEdit(record)}
                    />
                ) : null,
        },
    ];

    return (
        <>
            <QmDimensionTable.list
                rowKey={(record) => record.id_requisito}
                loading={loadingData}
                columns={columns}
                dataSource={dataSource}
                exportList={onExportList}
                toogleShowDeletedRecords={toggleShowDelete}
                handleNew={handleNew}
                onChange={handleTableChange}
            />

            {showModalNew && <WrappedFormRequirement onClose={handleCloseNew} />}
            {editRow && <WrappedFormRequirement record={editRow} onClose={handleCloseEdit} />}
        </>
    );
}
